module.exports = __webpack_public_path__ + "img/tmb.aedea1f4.svg";